import React, { createContext, useContext, useState, ReactNode, useEffect } from 'react';

interface SnackbarContextType {
  showSnackbar: (message: string) => void;
}

const SnackbarContext = createContext<SnackbarContextType | undefined>(undefined);

export const useSnackbar = () => {
  const context = useContext(SnackbarContext);
  if (!context) {
    throw new Error('useSnackbar must be used within a SnackbarProvider');
  }
  return context;
};

export const SnackbarProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [message, setMessage] = useState<string | null>(null);

  const showSnackbar = (msg: string) => {
    setMessage(msg);
    setTimeout(() => {
      setMessage((prev) => (prev === msg ? null : prev)); // Only clear if it hasn't been overwritten
    }, 7000);
  };

  useEffect(() => {
    const handleApiError = (event: Event) => {
      const customEvent = event as CustomEvent<string>;
      if (customEvent.detail) {
        showSnackbar(customEvent.detail);
      }
    };

    window.addEventListener('api_error', handleApiError);
    return () => {
      window.removeEventListener('api_error', handleApiError);
    };
  }, []);

  return (
    <SnackbarContext.Provider value={{ showSnackbar }}>
      {children}
      {message && (
        <div style={{
          position: 'fixed', bottom: '24px', left: '50%', transform: 'translateX(-50%)',
          backgroundColor: '#ef4444', color: 'white', padding: '12px 24px', borderRadius: '8px',
          boxShadow: '0 4px 6px rgba(0,0,0,0.1)', zIndex: 99999, fontWeight: 500,
          display: 'flex', alignItems: 'center', gap: '12px', minWidth: '300px', justifyContent: 'space-between'
        }}>
          <span>{message}</span>
          <button type="button" onClick={() => setMessage(null)} style={{ background: 'none', border: 'none', color: 'white', cursor: 'pointer', fontSize: '20px', lineHeight: 1, padding: 0 }}>&times;</button>
        </div>
      )}
    </SnackbarContext.Provider>
  );
};
